/* MONARCHIA — per-product size chart: illustrated fit models (Male A/B, Female A/B) with animated size poses, measurement lines and tags (vanilla JS) */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduce() { return !!mq.matches; }

  var ZMAP = { 'Shoulder': 'shoulder', 'Chest': 'chest', 'Waist': 'waist', 'Hip': 'hip', 'Length': 'length', 'Total Length': 'length', 'Out Seam Length': 'length', 'Sleeve Length': 'sleeve', 'Inseam': 'inseam', 'Inseam Length': 'inseam' };
  var SX = { S: .90, M: .96, L: 1.02, XL: 1.08, XXL: 1.14 };

  /* which translucent garment each product wears */
  var GMAP = {
    'jersey-tshirt': 'tee', 'ringer': 'ringer',
    'classic-oversized': 'ovs', 'terry-oversized': 'ovs', 'jersey-oversized': 'ovs',
    'oversized-shirt': 'shirt', 'polo': 'polo', 'pullover-hoodie': 'hoodie', 'sweatshirt': 'sweat',
    'aop-bomber-men': 'bomber', 'aop-bomber-women': 'bomber', 'baby-tee': 'baby', 'crop-top': 'crop', 'cropped-hoodie': 'chood',
    'mini-skirt': 'mini', 'pencil-skirt': 'pencil', 'tube-top': 'tube', 'bodycon-dress': 'bodycon', 'a-line-dress': 'aline',
    'sweatpants': 'spants', 'tie-dye-shorts': 'shorts', 'aop-sports-shorts': 'shorts', 'aop-shorts': 'shorts', 'terry-shorts': 'shorts'
  };
  var SHAPE_FALLBACK = { top: 'tee', crop: 'crop', tube: 'tube', dress: 'bodycon', mini: 'mini', pencil: 'pencil', pants: 'spants', shorts: 'shorts' };

  /* line layout per garment: h = horizontal zones [y, half-width]; len / ins = vertical lines {x, y, h}; slv = sleeve line ends (upper arm / forearm) */
  var TOPS = { shoulder: [252, 94], chest: [338, 98] };
  var GM = {
    tee:     { h: TOPS, len: { x: 160, y: 224, h: 244 }, slv: { u: 346, ox: 338 } },
    ringer:  { h: TOPS, len: { x: 160, y: 224, h: 244 }, slv: { u: 346, ox: 338 } },
    polo:    { h: TOPS, len: { x: 160, y: 224, h: 250 }, slv: { u: 346, ox: 338 } },
    shirt:   { h: TOPS, len: { x: 160, y: 224, h: 276 }, slv: { u: 346, ox: 338 } },
    ovs:     { h: { shoulder: [262, 112], chest: [350, 114] }, len: { x: 150, y: 220, h: 304 }, slv: { u: 392, ox: 352 } },
    hoodie:  { h: { shoulder: [258, 104], chest: [340, 106] }, len: { x: 150, y: 222, h: 280 }, slv: { u: 380, f: 496, ox: 334, fx: 328 } },
    sweat:   { h: { shoulder: [258, 104], chest: [340, 106] }, len: { x: 150, y: 222, h: 268 }, slv: { u: 380, f: 496, ox: 334, fx: 328 } },
    bomber:  { h: { shoulder: [258, 102], chest: [340, 104] }, len: { x: 150, y: 222, h: 248 }, slv: { u: 380, f: 496, ox: 334, fx: 328 } },
    baby:    { h: { shoulder: [258, 82], chest: [316, 84] }, len: { x: 160, y: 224, h: 172 }, slv: { u: 330, ox: 322 } },
    crop:    { h: { shoulder: [252, 94], chest: [320, 98] }, len: { x: 160, y: 224, h: 186 }, slv: { u: 346, ox: 338 } },
    chood:   { h: { shoulder: [258, 104], chest: [330, 104] }, len: { x: 150, y: 222, h: 198 }, slv: { u: 380, f: 496, ox: 334, fx: 328 } },
    tube:    { h: { chest: [304, 76], waist: [378, 70] }, len: { x: 160, y: 298, h: 96 } },
    bodycon: { h: { shoulder: [250, 58], chest: [330, 60], waist: [410, 52] }, len: { x: 160, y: 226, h: 414 } },
    aline:   { h: { shoulder: [250, 58], chest: [330, 60], waist: [410, 54] }, len: { x: 160, y: 226, h: 426 } },
    mini:    { h: { waist: [472, 72], hip: [516, 90] }, len: { x: 150, y: 462, h: 100 } },
    pencil:  { h: { waist: [472, 72], hip: [530, 76] }, len: { x: 150, y: 462, h: 213 } },
    spants:  { h: { waist: [476, 78], hip: [530, 82] }, len: { x: 140, y: 462, h: 244 }, ins: { x: 200, y: 548, h: 158, side: 'right' } },
    shorts:  { h: { waist: [474, 78], hip: [530, 84] }, len: { x: 140, y: 462, h: 142 }, ins: { x: 200, y: 548, h: 56, side: 'right' } }
  };
  var LOWER = { mini: 1, pencil: 1, spants: 1, shorts: 1 };
  var GROUPS = ['Tees', 'Men', 'Women', 'Bottoms'];
  var RIGHT_X = 394, LEFT_X = -6;
  var OLDK = [226, 252, 338, 472, 530, 548, 706];   /* landmark y's of the original line layout: neck, shoulder, chest, waist, hip, crotch, hem */
  var CHARS = ['male_a', 'female_a'];
  var ICONS = {
    tee: 'M8 4 3 7.5 5.6 10.6 8 9.4V20h8V9.4l2.4 1.2L21 7.5 16 4q-4 3.2-8 0Z',
    ringer: 'M8 4 3 7.5 5.6 10.6 8 9.4V20h8V9.4l2.4 1.2L21 7.5 16 4q-4 3.2-8 0ZM5 8.9l2.2 1.6M19 8.9l-2.2 1.6',
    ovs: 'M8.5 4 2.5 8l1.4 5 3.6-.8V20h9v-7.8l3.6.8 1.4-5-6-4q-3.5 3-7 0Z',
    polo: 'M8 4 3 7.5 5.6 10.6 8 9.4V20h8V9.4l2.4 1.2L21 7.5 16 4l-4 4.4ZM12 8.4V20',
    shirt: 'M8 4 3 7.5 5.6 10.6 8 9.4V20h8V9.4l2.4 1.2L21 7.5 16 4l-4 4.4ZM12 8.4V20M9.6 4.6 12 8.4l2.4-3.8',
    hoodie: 'M8 4.5 3 8.5 4 18l3-.5.5-6V20h9v-8.5l.5 6 3 .5 1-9.5-5-4Q12 3 8 4.5ZM9.4 5.6Q12 9.5 14.6 5.6M12 11v3',
    baby: 'M8 6 3.5 9 5.6 12 8 11v4h8v-4l2.4 1L20.5 9 16 6q-4 2.8-8 0Z',
    tube: 'M6 8Q12 10 18 8V16Q12 18 6 16Z',
    bodycon: 'M9 3 8.4 8 7.6 14 8 21h8l.4-7-.8-6L15 3M8.4 8h7.2',
    aline: 'M9.4 3 8.6 8 5 21h14L15.4 8 14.6 3M8.6 8h6.8',
    mini: 'M8 5h8l3.4 12H4.6ZM8 5q4 1.6 8 0',
    pencil: 'M8 4h8l1 16H7ZM8 4q4 1.4 8 0',
    spants: 'M7 3h10l1 18h-4.4L12 9.5 10.4 21H6Z',
    shorts: 'M7 4h10l1 11h-5l-1-4-1 4H6Z'
  };
  ICONS.sweat = ICONS.hoodie; ICONS.bomber = ICONS.hoodie; ICONS.chood = ICONS.hoodie; ICONS.crop = ICONS.baby;
  function lerp(a, b, t) { return a + (b - a) * t; }

  function fmt(v) { return String(Math.round(v * 10) / 10); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  /* lazy image loader: srcset (1x small / 2x full) + src fallback, set only when the image is actually needed */
  function ld(im) {
    if (!im || im.getAttribute('src')) return;
    var ss = im.getAttribute('data-srcset'); if (ss) im.srcset = ss;
    im.src = im.getAttribute('data-src');
  }

  function tween(el, to, dur) {
    if (!el) return;
    var from = el.__v;
    el.__v = to;
    if (el.__raf) cancelAnimationFrame(el.__raf);
    if (from === undefined || from === null || from === to || reduce() || dur === 0) { el.textContent = fmt(to); return; }
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = p >= 1 ? fmt(to) : fmt(from + (to - from) * e);
      if (p < 1) el.__raf = requestAnimationFrame(step);
    }
    el.__raf = requestAnimationFrame(step);
  }

  function init(root) {
    if (!root || root.__mnrSc) return;
    root.__mnrSc = true;
    var dataEl = root.querySelector('script[data-sc-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sizes = data.sizes || ['S', 'M', 'L', 'XL', 'XXL'];
    var list = (data.products || []).filter(Boolean);
    var byKey = {};
    list.forEach(function (p) { byKey[p.k] = p; });

    var fig = root.querySelector('[data-sc-fig]');
    var stage = root.querySelector('[data-sc-stage]');
    var empty = root.querySelector('[data-sc-empty]');
    var sel = root.querySelector('[data-sc-select]');
    var modelWrap = root.querySelector('[data-sc-models]');
    var chipName = fig.querySelector('[data-sc-chipname]'), chipMeta = fig.querySelector('[data-sc-chipmeta]'), chipIcon = fig.querySelector('[data-sc-icon]');
    var CAL = {};
    try { CAL = JSON.parse(fig.getAttribute('data-cal') || '{}'); } catch (e) { CAL = {}; }
    var modelEls = {};
    each(fig.querySelectorAll('.sc-model'), function (m) {
      modelEls[m.getAttribute('data-char')] = m;
      each(m.querySelectorAll('.sc-pose:not(.sc-of)'), function (pz) { pz.__i = sizes.indexOf(pz.getAttribute('data-size')); });
    });
    var readout = root.querySelector('[data-sc-readout]');
    var tableWrap = root.querySelector('[data-sc-table]');
    var spec = root.querySelector('[data-sc-spec]');
    var figTag = root.querySelector('[data-sc-figtag]');
    var tableUnit = root.querySelector('[data-sc-table-unit]');
    var hasSelector = root.getAttribute('data-selector') === 'true';

    var q = null;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }
    var qGet = function (k) { return q ? q.get(k) : null; };

    var state = {
      key: (hasSelector && qGet('chart')) || root.getAttribute('data-key') || '',
      size: ((qGet('size') || root.getAttribute('data-default-size') || 'M') + '').toUpperCase(),
      unit: ((qGet('unit') || root.getAttribute('data-default-unit') || 'in') + '').toLowerCase() === 'cm' ? 'cm' : 'in',
      char: 'male_a'
    };
    state.key = String(state.key).toLowerCase().trim();
    /* generic or unknown key: try to resolve to the closest chart (e.g. 'skirt' -> pencil-skirt / mini-skirt) by the key text, then by the page title */
    var plainMatches = [];
    if (!byKey[state.key] && state.key) {
      var ttl = (document.title || '').toLowerCase();
      var near = list.filter(function (p) { return p.k.indexOf(state.key) >= 0 || state.key.indexOf(p.k) >= 0; });
      if (near.length > 1) { var byT = near.filter(function (p) { return ttl.indexOf(p.k.split('-')[0]) >= 0; }); if (byT.length === 1) near = byT; }
      if (near.length === 1) state.key = near[0].k; else plainMatches = near;
    }
    if (!byKey[state.key]) state.key = hasSelector && list.length ? (byKey[root.getAttribute('data-key')] ? root.getAttribute('data-key') : list[0].k) : state.key;
    if (sizes.indexOf(state.size) < 0) state.size = sizes.indexOf('M') >= 0 ? 'M' : sizes[0];
    var gq = (qGet('gender') || '').toLowerCase();
    if (gq === 'female' || gq === 'male') state.char = gq + '_a';
    var cq = (qGet('char') || '').toLowerCase();
    if (CHARS.indexOf(cq) >= 0) state.char = cq;
    function charGender(c) { return c.split('_')[0]; }
    function charsFor(p) { return p.g === 'unisex' ? CHARS : CHARS.filter(function (c) { return charGender(c) === p.g; }); }

    /* ---- selector (native select is rebuilt here, then upgraded to the branded dropdown) ---- */
    if (sel) {
      var html = '';
      GROUPS.forEach(function (g) {
        var items = list.filter(function (p) { return p.grp === g; });
        if (!items.length) return;
        html += '<optgroup label="' + esc(g) + '">';
        items.forEach(function (p) { html += '<option value="' + esc(p.k) + '">' + esc(p.l) + '</option>'; });
        html += '</optgroup>';
      });
      sel.innerHTML = html;
      sel.value = state.key;
      if (window.MonarchiaSelect) window.MonarchiaSelect.enhance(sel);
    }

    function measure(p, zone) {
      for (var i = 0; i < p.m.length; i++) if (ZMAP[p.m[i].z] === zone) return p.m[i];
      return null;
    }
    function val(m, sIdx, unit) { return m.v[sIdx][unit === 'cm' ? 1 : 0]; }
    function ratio(m, sIdx) {
      var mi = sizes.indexOf('M'); if (mi < 0) mi = 0;
      var r = m.v[sIdx][0] / m.v[mi][0];
      return Math.max(0.86, Math.min(1.16, r));
    }
    var tagEls = {};
    each(fig.querySelectorAll('.sc-tag'), function (t) { tagEls[t.getAttribute('data-z')] = t; });
    var firstRender = true, lastKey = null, lastSIdx = -1, lastChar = null;
    var STANCE = [{ x: -.4, r: -.4, sx: .955, sy: 1.008 }, { x: 0, r: 0, sx: 1, sy: 1 }, { x: .6, r: .9, sx: 1.025, sy: 1 }, { x: 1, r: -1.7, sx: 1.055, sy: .996 }, { x: 0, r: 0, sx: 1.1, sy: .985 }];
    var hopEl = fig.querySelector('[data-sc-hop]');
    function play(cls, dir) {
      if (!hopEl || reduce()) return;
      hopEl.style.setProperty('--dir', dir || 1);
      hopEl.classList.remove('is-step', 'is-enter'); void hopEl.offsetWidth; hopEl.classList.add(cls);
    }


    /* arm-pose loop: each worn outfit has the base pose + up to 3 arm-pose frames (hip / hair or pockets / wave);
       frames cross-fade on a timer, a size change jumps to a different frame */
    var HOLD = 1900, FADE = 650, loopTimer = 0;
    function armFrames(of) {
      var out = [of.querySelector('.sc-body')];
      each(of.querySelectorAll('.sc-arm'), function (a) { if (a.getAttribute('src') && a.complete && a.naturalWidth > 0) out.push(a); });
      return out;
    }
    function loadArms(of) {
      each(of.querySelectorAll('.sc-hair[data-k]:not([data-k="base"])'), ld);
      each(of.querySelectorAll('.sc-arm[data-src]'), function (a) {
        if (a.getAttribute('src')) return;
        a.addEventListener('load', function () { a.setAttribute('data-ok', '1'); }, { once: true });
        ld(a);
      });
    }
    function setHair(of, key) { each(of.querySelectorAll('.sc-hair'), function (h) { h.classList.toggle('is-off', (h.getAttribute('data-k') || 'base') !== key); }); }
    function showFrame(of, idx, fade) {
      var fr = armFrames(of), cur = of.__f || 0;
      if (idx >= fr.length) idx = 0;
      if (idx === cur && of.__fi) return;
      var nf = fr[idx], pv = fr[cur] || fr[0];
      of.__z = (of.__z || 2) + 1; of.__fi = 1;
      clearTimeout(of.__ct);
      each(fr, function (f) { if (f !== pv && f !== nf) { f.style.transition = 'none'; f.style.opacity = 0; } });
      if (!fade || reduce()) {
        each(fr, function (f) { f.style.transition = 'none'; f.style.opacity = f === nf ? 1 : 0; f.style.zIndex = f === nf ? of.__z : 1; });
      } else {
        pv.style.transition = 'none'; pv.style.opacity = 1; pv.style.zIndex = of.__z - 1;
        nf.style.transition = 'none'; nf.style.opacity = 0; nf.style.zIndex = of.__z; void nf.offsetWidth;
        nf.style.transition = 'opacity ' + (fade === 'fast' ? 380 : FADE) + 'ms ease-in-out'; nf.style.opacity = 1;
        of.__ct = setTimeout(function () { if (pv !== nf) { pv.style.transition = 'none'; pv.style.opacity = 0; } }, (fade === 'fast' ? 380 : FADE) + 40);
      }
      of.__f = idx;
      setHair(of, idx === 0 ? 'base' : nf.getAttribute('data-k'));
    }
    function activeOutfit() { return fig.querySelector('.sc-model.is-active .sc-of.is-active'); }
    function loopTick() {
      if (reduce() || document.hidden || !inView) return;
      var of = activeOutfit(); if (!of) return;
      var n = armFrames(of).length; if (n < 2) return;
      showFrame(of, ((of.__f || 0) + 1) % n, true);
    }
    function loopRestart() { clearInterval(loopTimer); loopTimer = 0; if (!reduce() && (typeof inView === 'undefined' || inView) && !document.hidden) loopTimer = setInterval(loopTick, HOLD); }
    function loopJump(of) {   /* a size change: jump to a different pose right away */
      var n = armFrames(of).length; if (n < 2 || reduce()) return;
      var cur = of.__f || 0, nx = cur + 1 + Math.floor(Math.random() * (n - 1)); nx = nx % n; if (nx === cur) nx = (cur + 1) % n;
      showFrame(of, nx, 'fast'); loopRestart();
    }

    var firstPaint = true;
    var OSX = [1, 1.008, 1.018, 1.03, 1.045];   /* outfit layers are drawn on the S body: widen a touch per size */
    /* the selected product is worn: its outfit layer fades in over the base tee poses (loaded on demand) */
    function wear(m, on, gm, sIdx) {
      var of = on && gm !== 'tee' ? m.querySelector('.sc-of[data-g="' + gm + '"]') : null, show = false;
      m.__g = gm; m.__s = sIdx;
      if (of) {
        var im = of.querySelector('.sc-body');
        if (!im.getAttribute('src')) {
          im.addEventListener('load', function () { if (m.__g === gm && m.classList.contains('is-active')) wear(m, true, gm, m.__s); }, { once: true });
          ld(im);
          ld(of.querySelector('.sc-hair[data-k="base"]'));
        }
        show = im.complete && im.naturalWidth > 0;
        if (show) loadArms(of);
      }
      each(m.querySelectorAll('.sc-of'), function (o) {
        var a = show && o === of;
        var was = o.classList.contains('is-active');
        o.classList.toggle('is-active', a);
        if (a && !was) { o.__f = 0; o.__fi = 0; showFrame(o, 0, false); o.__fi = 1; loopRestart(); }
        else if (a && o.__s !== undefined && o.__s !== sIdx) loopJump(o);
        if (a) o.__s = sIdx;
        o.style.setProperty('--sx', OSX[sIdx] || 1);
        o.style.setProperty('--sy', 1 + (OSX[sIdx] - 1) * .2);
      });
      each(m.querySelectorAll('.sc-pose:not(.sc-of)'), function (pz) {
        var o = pz.__i - sIdx;
        if (on && (Math.abs(o) <= 1 && !of || (pz.__i === 1 && !of))) loadPose(pz);
        pz.style.setProperty('--o', o); pz.style.setProperty('--a', Math.abs(o));
        pz.classList.toggle('is-active', on && o === 0 && !show);
      });
      m.classList.toggle('is-wearing', show);
    }
    function loadPose(pz) { each(pz.querySelectorAll('img[data-src]'), ld); }
    function activate(sIdx, charChanged, gm) {
      each(Object.keys(modelEls), function (id) {
        var m = modelEls[id], on = id === state.char;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-hidden', 'true');
        wear(m, on, gm, sIdx);
        if (on && !firstPaint && !reduce()) { m.classList.remove('is-pop'); void m.offsetWidth; m.classList.add('is-pop'); }
      });
      firstPaint = false;
    }
    /* idle: only the active model's remaining base poses (tee) are fetched; the other model + other outfits load when chosen */
    function warm() {
      var later = function () {
        var m = fig.querySelector('.sc-model.is-active'); if (!m) return;
        if (!m.classList.contains('is-wearing')) each(m.querySelectorAll('.sc-pose:not(.sc-of)'), loadPose);
      };
      if (window.requestIdleCallback) window.requestIdleCallback(later, { timeout: 4000 }); else setTimeout(later, 2500);
    }
    /* pause the loops (arm timer, CSS idle/breathe/hair) when the figure is offscreen or the tab is hidden */
    var inView = true;
    function syncLoop() { clearInterval(loopTimer); loopTimer = 0; if (inView && !document.hidden && !reduce()) loopTimer = setInterval(loopTick, HOLD); fig.classList.toggle('is-paused', !inView); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; syncLoop(); }, { rootMargin: '80px 0px' }).observe(fig);
    document.addEventListener('visibilitychange', syncLoop);

    /* pointer parallax: the whole model + card grid tilts gently toward the cursor */
    var card = fig.closest('.mnr-sg__figure') || fig;
    var par = { x: 0, y: 0, tx: 0, ty: 0, raf: 0 };
    function parStep() {
      par.x += (par.tx - par.x) * .12; par.y += (par.ty - par.y) * .12;
      fig.style.setProperty('--px', par.x.toFixed(3)); fig.style.setProperty('--py', par.y.toFixed(3));
      card.style.setProperty('--px', par.x.toFixed(3)); card.style.setProperty('--py', par.y.toFixed(3));
      if (Math.abs(par.tx - par.x) > .002 || Math.abs(par.ty - par.y) > .002) par.raf = requestAnimationFrame(parStep); else par.raf = 0;
    }
    function parGo() { if (!par.raf) par.raf = requestAnimationFrame(parStep); }
    card.addEventListener('pointermove', function (e) {
      if (reduce() || e.pointerType === 'touch') return;
      var r = card.getBoundingClientRect();
      par.tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - .5) * 2));
      par.ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - .5) * 2));
      parGo();
    });
    card.addEventListener('pointerleave', function () { par.tx = 0; par.ty = 0; parGo(); });
    /* touch devices: a slow idle drift instead of hover */

    function setTag(z, m, o, sIdx, newProduct, resetVals) {
      var t = tagEls[z]; if (!t) return;
      var on = !!(m && o);
      t.classList.toggle('is-on', on);
      if (!on) return;
      var anchor = o.left ? 'end' : 'start';
      t.style.setProperty('--tx', o.x.toFixed(1));
      t.style.setProperty('--ty', o.y.toFixed(1));
      t.style.setProperty('--dy', (o.dy || 0).toFixed(1));
      t.style.setProperty('--ll', o.ll.toFixed(1));
      var n = t.querySelector('.sc-tag__n'), v = t.querySelector('.sc-tag__v');
      var tx = o.left ? -9 : 9;
      n.setAttribute('x', tx); n.setAttribute('y', -4); v.setAttribute('x', tx); v.setAttribute('y', 18);
      n.setAttribute('text-anchor', anchor); v.setAttribute('text-anchor', anchor);
      n.textContent = m.n.toUpperCase();
      var span = v.__span;
      if (!span) {
        v.textContent = '';
        span = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        var uEl = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        uEl.setAttribute('class', 'sc-tag__u');
        v.__span = span; v.__unit = uEl;
        v.appendChild(span); v.appendChild(uEl);
      }
      v.__unit.textContent = ' ' + (state.unit === 'cm' ? 'CM' : 'IN');
      if (newProduct || resetVals) span.__v = undefined;
      tween(span, val(m, sIdx, state.unit), 600);
    }

    /* unrecognised chart type: never leave empty space. Show a plain table (all sizes, inches / cm) for each close match,
       or hide the whole section when there is nothing to show */
    function plainTable(p) {
      var t = '<table class="mnr-table"><caption>' + esc(p.l) + ' (inches / cm)</caption><thead><tr><th scope="col">Size</th>';
      p.m.forEach(function (m) { t += '<th scope="col">' + esc(m.n) + '</th>'; });
      t += '</tr></thead><tbody>';
      sizes.forEach(function (s, si) {
        t += '<tr><th scope="row">' + esc(s) + '</th>';
        p.m.forEach(function (m) { t += '<td>' + fmt(m.v[si][0]) + ' / ' + fmt(m.v[si][1]) + '</td>'; });
        t += '</tr>';
      });
      return t + '</tbody></table>';
    }
    function renderFallback() {
      var fb = root.querySelector('[data-sc-fallback]');
      var tw = root.querySelector('.mnr-sg__tables');
      if (stage) stage.hidden = true;
      if (tw) tw.hidden = true;
      if (fb && plainMatches.length) {
        fb.innerHTML = plainMatches.map(plainTable).join('');
        fb.hidden = false;
        if (empty) empty.hidden = true;
      } else {
        var wrap = root.closest ? root.closest('[data-mnr-sc-section]') : null;
        if (root.getAttribute('data-hide-empty') || wrap) { root.hidden = true; if (wrap) wrap.hidden = true; }
        else if (empty) empty.hidden = false;
      }
    }

    function render(opts) {
      opts = opts || {};
      var p = byKey[state.key];
      if (!p) { renderFallback(); return; }
      var fb = root.querySelector('[data-sc-fallback]'); if (fb) fb.hidden = true;
      var tw0 = root.querySelector('.mnr-sg__tables'); if (tw0) tw0.hidden = false;
      if (stage) stage.hidden = false; if (empty) empty.hidden = true;
      var sIdx = sizes.indexOf(state.size);
      var newProduct = lastKey !== state.key;
      lastKey = state.key;

      var allowed = charsFor(p);
      if (allowed.indexOf(state.char) < 0) state.char = allowed[0];
      var charChanged = fig.getAttribute('data-char') !== state.char;
      if (modelWrap) {
        each(modelWrap.querySelectorAll('[data-sc-char]'), function (b) {
          var id = b.getAttribute('data-sc-char');
          b.hidden = allowed.indexOf(id) < 0;
          b.setAttribute('aria-pressed', id === state.char ? 'true' : 'false');
        });
        modelWrap.hidden = allowed.length < 2;
      }
      var gm = GMAP[p.k] || SHAPE_FALLBACK[p.s] || 'tee';
      var cfg = GM[gm];
      var cal = CAL[state.char] || CAL.male_a;
      fig.setAttribute('data-char', state.char);
      fig.setAttribute('data-gender', charGender(state.char));
      fig.setAttribute('data-garment', gm);
      fig.setAttribute('data-size', state.size);
      var lx = 1 + ((SX[state.size] || .96) / .96 - 1) * .8;
      activate(sIdx, charChanged, gm);
      var st = STANCE[sIdx] || STANCE[1];
      if (hopEl) { var stp = hopEl.firstElementChild; stp.style.setProperty('--stx', st.x); stp.style.setProperty('--str', st.r); stp.style.setProperty('--ssx', st.sx); stp.style.setProperty('--ssy', st.sy); }
      if (lastKey !== null && !firstRender) {
        if (newProduct || state.char !== lastChar) play('is-enter');
        else if (sIdx !== lastSIdx) play('is-step', sIdx > lastSIdx ? 1 : -1);
      }
      firstRender = false; lastSIdx = sIdx; lastChar = state.char;
      /* map the original line layout onto this character's body landmarks */
      var K = cal.k, HW = cal.hw;
      function Y(oy) {
        var i = 0;
        while (i < OLDK.length - 2 && oy > OLDK[i + 1]) i++;
        return K[i] + (oy - OLDK[i]) * (K[i + 1] - K[i]) / (OLDK[i + 1] - OLDK[i]);
      }
      function HX(zone, v) {  /* old half-width -> svg half-width */
        var base = { shoulder: [94, HW[0]], chest: [98, HW[1]], waist: [78, HW[2]], hip: [84, HW[3]] }[zone];
        return v * base[1] / base[0] * lx;
      }

      each(root.querySelectorAll('[data-sc-size]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sc-size') === state.size ? 'true' : 'false'); });
      each(root.querySelectorAll('[data-sc-unit]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sc-unit') === state.unit ? 'true' : 'false'); });
      if (sel && sel.value !== state.key) { sel.value = state.key; if (window.MonarchiaSelect) window.MonarchiaSelect.refresh(sel); }
      if (spec) spec.textContent = p.l + ' / ' + (p.g === 'unisex' ? 'Unisex' : (p.g === 'male' ? 'Men' : 'Women')) + ' / Size ' + state.size;
      if (figTag) figTag.textContent = 'Fig. 01 / ' + ((CAL[state.char] || {}).label || 'Model') + ' / ' + state.size;
      if (chipName) chipName.textContent = p.l;
      if (chipMeta) chipMeta.textContent = (p.g === 'unisex' ? 'Unisex' : (p.g === 'male' ? 'Men' : 'Women')) + ' / Size ' + state.size;
      if (chipIcon) chipIcon.innerHTML = '<path d="' + (ICONS[gm] || ICONS.tee) + '"/>';

      /* garment length follows the size */
      var lenM = measure(p, 'length');
      var lenR = lenM ? ratio(lenM, sIdx) : 1;

      /* horizontal lines + vertical lines sitting on the garment */
      var right = [], left = [];
      var lowerG = !!LOWER[gm];
      var oY = lowerG ? 462 : 226;
      each(fig.querySelectorAll('.sc-m[data-z]'), function (g) {
        var z = g.getAttribute('data-z');
        var m = measure(p, z), on = false;
        if (z === 'length' && cfg.len && m) {
          on = true;
          var oy0 = oY + (cfg.len.y - oY) * lenR, hh = cfg.len.h * lenR;
          var y0 = Y(oy0), y1 = Y(oy0 + hh);
          var x = 200 - (200 - cfg.len.x) * HW[1] / 98 * lx;
          g.style.setProperty('--x', x.toFixed(1)); g.style.setProperty('--y', y0.toFixed(1)); g.style.setProperty('--h', (y1 - y0).toFixed(1));
          left.push({ z: z, m: m, y: y0 + (y1 - y0) * .62, x: x });
        } else if (z === 'inseam' && cfg.ins && m) {
          on = true;
          var ih = cfg.ins.h * ratio(m, sIdx);
          var i0 = Y(cfg.ins.y), i1 = Y(cfg.ins.y + ih);
          g.style.setProperty('--x', 200); g.style.setProperty('--y', i0.toFixed(1)); g.style.setProperty('--h', (i1 - i0).toFixed(1));
          right.push({ z: z, m: m, y: i0 + (i1 - i0) * .55, x: 203 });
        } else if (z === 'sleeve') {
          var sm = m;
          if (sm && cfg.slv) {
            on = true;
            var sr = Math.max(.92, Math.min(1.08, ratio(sm, sIdx)));
            var sEnd = cfg.slv.f ? 372 + (cfg.slv.f - 372) * sr : 252 + (cfg.slv.u - 252) * sr;
            var s0 = Y(252), s1 = Y(sEnd);
            var sx = 200 + HW[0] * lx + 10;
            g.style.setProperty('--x', sx.toFixed(1)); g.style.setProperty('--y', s0.toFixed(1)); g.style.setProperty('--h', (s1 - s0).toFixed(1));
            right.push({ z: z, m: sm, y: s0 + (s1 - s0) * .5, x: sx });
          }
        } else if (cfg.h[z] && m && z !== 'length' && z !== 'inseam') {
          on = true;
          var zy = Y(oY + (cfg.h[z][0] - oY) * lenR), hw = HX(z, cfg.h[z][1]);
          g.style.setProperty('--y', zy.toFixed(1)); g.style.setProperty('--w', hw.toFixed(1));
          right.push({ z: z, m: m, y: zy, x: 200 + hw + 3 });
        }
        g.classList.toggle('is-on', on);
      });

      /* tags: resolve overlaps per side */
      function place(arr, isLeft) {
        arr.sort(function (a, b) { return a.y - b.y; });
        var prev = -1e9;
        arr.forEach(function (o) {
          var ty = o.y; var dy = 0;
          if (ty < prev + 46) { dy = prev + 46 - ty; }
          prev = ty + dy;
          o.dy = dy; o.left = isLeft; o.ll = isLeft ? (LEFT_X - o.x) : (RIGHT_X - o.x);
        });
      }
      place(right, false); place(left, true);
      var used = {};
      right.concat(left).forEach(function (o) { used[o.z] = 1; setTag(o.z, o.m, o, sIdx, newProduct, opts.unit); });
      Object.keys(tagEls).forEach(function (z) { if (!used[z]) tagEls[z].classList.remove('is-on'); });

      /* readout rows */
      if (readout) {
        if (newProduct || readout.__key !== state.key) {
          readout.__key = state.key;
          var rh = '';
          p.m.forEach(function (m, i) {
            var z = ZMAP[m.z] || '';
            rh += '<li class="mnr-readout__row" data-sc-row="' + esc(z) + '" tabindex="0"><span class="mnr-readout__idx">' + (i < 9 ? '0' : '') + (i + 1) + '</span><span class="mnr-readout__name">' + esc(m.n) + '</span><span class="mnr-readout__val"><b data-sc-val="' + i + '"></b><small data-sc-ulabel></small></span></li>';
          });
          readout.innerHTML = rh;
        }
        each(readout.querySelectorAll('[data-sc-val]'), function (b) {
          var m = p.m[parseInt(b.getAttribute('data-sc-val'), 10)];
          if (newProduct || opts.unit) b.__v = undefined;
          tween(b, val(m, sIdx, state.unit), 600);
        });
        each(readout.querySelectorAll('[data-sc-ulabel]'), function (u) { u.textContent = state.unit === 'cm' ? 'cm' : 'in'; });
      }

      /* table */
      if (tableWrap) {
        var th = '<table class="mnr-table"><caption class="visually-hidden">' + esc(p.l) + ' size chart</caption><thead><tr><th scope="col">Size</th>';
        p.m.forEach(function (m) { th += '<th scope="col" data-sc-col>' + esc(m.n) + '</th>'; });
        th += '</tr></thead><tbody>';
        sizes.forEach(function (s, si) {
          th += '<tr data-sc-trow="' + esc(s) + '"' + (s === state.size ? ' class="is-current"' : '') + '><th scope="row">' + esc(s) + '</th>';
          p.m.forEach(function (m) { th += '<td>' + fmt(val(m, si, state.unit)) + '</td>'; });
          th += '</tr>';
        });
        th += '</tbody></table>';
        tableWrap.innerHTML = th;
      }
      if (tableUnit) tableUnit.textContent = 'Garment measurements in ' + (state.unit === 'cm' ? 'centimetres' : 'inches');

      if (hasSelector && window.history && history.replaceState && !opts.init) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('chart', state.key);
          history.replaceState(null, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-sc-size],[data-sc-unit],[data-sc-char],[data-sc-trow]') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-sc-size')) { state.size = t.getAttribute('data-sc-size'); render(); }
      else if (t.hasAttribute('data-sc-unit')) { state.unit = t.getAttribute('data-sc-unit'); render({ unit: true }); }
      else if (t.hasAttribute('data-sc-char')) { state.char = t.getAttribute('data-sc-char'); render({ keepVals: true }); }
      else if (t.hasAttribute('data-sc-trow')) { state.size = t.getAttribute('data-sc-trow'); render(); }
    });
    if (sel) sel.addEventListener('change', function () { state.key = sel.value; render({ unit: true }); });
    function hot(row, on) {
      var z = row.getAttribute('data-sc-row');
      if (on && z) fig.setAttribute('data-hot', z); else fig.removeAttribute('data-hot');
    }
    if (readout) {
      readout.addEventListener('mouseover', function (e) { var r = e.target.closest && e.target.closest('[data-sc-row]'); if (r) hot(r, true); });
      readout.addEventListener('mouseout', function (e) { var r = e.target.closest && e.target.closest('[data-sc-row]'); if (r) hot(r, false); });
      readout.addEventListener('focusin', function (e) { var r = e.target.closest && e.target.closest('[data-sc-row]'); if (r) hot(r, true); });
      readout.addEventListener('focusout', function (e) { var r = e.target.closest && e.target.closest('[data-sc-row]'); if (r) hot(r, false); });
    }

    root.classList.add('is-ready');
    render({ init: true });
    warm();
  }

  function boot() { each(document.querySelectorAll('[data-mnr-sc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-mnr-sc]') : null;
    if (r) init(r);
  });
})();
